import React from "react";
import Slider from "react-slick";
import "./App.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Navbar from "./components/Navbar"; // Importa la Navbar

import image1 from "./assets/laser.png";
import image2 from "./assets/scanner.png";
import image3 from "./assets/sala.png";
import image4 from "./assets/radiofrequenza.png";
import image5 from "./assets/tac.png";

import ricci from "./assets/ricci.JPG";
import lauricella from "./assets/lauricella.jpeg";
import destro from "./assets/destro.jpeg";
import andreolli from "./assets/andreolli.JPG";

const imageListData = [
  {
    id: 1,
    imgSrc: image1,
  },
  {
    id: 2,
    imgSrc: image2,
  },
  {
    id: 3,
    imgSrc: image3,
  },
  {
    id: 4,
    imgSrc: image4,
  },
  {
    id: 5,
    imgSrc: image5,
  },
  // Add the remaining images in the same way
];

const imagePersonData = [
  {
    id: 2,
    imgSrc: lauricella,
    text: "Dr. Alberto Lauricella",
  },
  {
    id: 3,
    imgSrc: destro,
    text: "Dr. Luigi Destro",
  },
  {
    id: 1,
    imgSrc: ricci,
    text: "Dr.ssa Carlotta Ricci",
  },
  {
    id: 4,
    imgSrc: andreolli,
    text: "Dr. Massimiliano Andreolli",
  },
];

function App() {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
  };

  return (
    <div className="App">
      <Navbar /> {/* Inserisci la Navbar qui */}
      <header className="hero">
        <div className="hero-content">
          <h1>Studio Dentistico Lauricella</h1>
          <p>
            Tre generazioni di sorrisi e ci apprestiamo a risolvere i problemi
            della quarta
          </p>
          <a href="#whatwedo" className="cta-button">
            Prenota
          </a>
        </div>
      </header>
      {/* What We Do Section */}
      <section id="whatwedo" className="content-section">
        <div className="section-content">
          {/* Left Section: Carousel */}
          <div className="carousel-section">
            <Slider {...sliderSettings}>
              {imageListData.map((item) => (
                <div key={item.id} className="carousel-item">
                  <img src={item.imgSrc} alt={item.text} />
                  <p>{item.text}</p>
                </div>
              ))}
            </Slider>
          </div>

          {/* Right Section: Title and Description */}
          <div className="text-section">
            <h2>Cosa facciamo</h2>
            <p>
              Benvenuto allo Studio Dentistico Lauricella, dove la tradizione e
              l'innovazione si incontrano per garantirvi un sorriso perfetto.
              Fondata nel 1982, la nostra clinica ha radici profonde nella cura
              e nel benessere dentale della nostra comunità. Con un'attenzione
              particolare ad ogni branca dell'odontoiatria, siamo qui per
              assicurarvi trattamenti all'avanguardia in un ambiente accogliente
              e professionale. Affidateci il vostro sorriso, noi lo faremo
              brillare.
            </p>
          </div>
        </div>
      </section>
      {/* Who We Are Section */}
      <section id="whoweare" className="content-section">
        <h2 style={{ textAlign: "left" }}>Chi siamo</h2>
        <div className="image-list">
          {imagePersonData.map((item) => (
            <div key={item.id} className="image-item">
              <img src={item.imgSrc} alt={item.text} />
              <p>{item.text}</p>
            </div>
          ))}
        </div>
      </section>
      {/* Contact Section */}
      <section className="contact-section" id="contatti">
        <div className="map-container">
          <iframe
            title="Google Maps Location"
            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2795.3325839254694!2d10.20629047608405!3d45.52351242947963!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4781767623ef56af%3A0x5f748f6a7126d20b!2sVia%20Rodi%2C%2069%2C%2025124%20Brescia%20BS!5e0!3m2!1sit!2sit!4v1730641466133!5m2!1sit!2sit"
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen=""
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          ></iframe>
        </div>
        <div className="contact-info">
          <p>
            <strong>Indirizzo:</strong> Via Rodi, 69 25124 Brescia BS
          </p>
          <p>
            <strong>Email:</strong> info@prevident.it
          </p>
          <p>
            <strong>Telefono: </strong>
            <a href="tel:123-456-7890">030 220038</a>
          </p>
          <p>
            <strong>Orari:</strong> Lun-Gio: 9:00 - 19:00 <br></br>
            <strong>Orari:</strong> Mer : Chiuso <br></br>
            <strong>Orari:</strong> Ven: 9:00 - 14:00
          </p>
        </div>
      </section>
    </div>
  );
}

export default App;
